import { logout } from './api';

// The shared sign-out: flag the button, best-effort clear the server session,
// then a full load to the door this person belongs at, which re-probes /me →
// signed out → the sign-in screen. The load happens even if logout() fails, so
// a dead session still drops the user to sign-in.
//
// THE DOOR IS A PARAMETER (Freddi, 2026-09-14). It was always `/` — the desk's
// root — which for a customer resolves to the DESK's signed-out card, the one
// that says "sign in with your kennel Google or Microsoft account". That is the
// wrong sentence for somebody who was looking at their dog's stay, and it is
// the same wrong-door class the role router fixed an hour earlier. The desk and
// the staff view keep `/`; the customer app passes its own.
export async function signOutSession(
  setSigningOut: (v: boolean) => void,
  to = '/',
  // The navigation is a SEAM, the same way `api.ts` injects its 401 redirect —
  // so which door a sign-out sends you to is a thing a test can read rather
  // than a thing you have to take on trust from the call site.
  go: (to: string) => void = (href) => window.location.assign(href),
): Promise<void> {
  setSigningOut(true);
  try {
    await logout();
  } catch {
    /* drop to the sign-in screen even if the call fails */
  }
  go(to);
}
